import React from "react";
import { AssociatedPerson } from "../../../../types/cdd-records.types";
import { formatDateShort } from "../../../../utils/dateFormatters";
import { getPositionColor, positionColors } from "./entityProfileConfig";

// Re-export for consumers that import from this file
export { getPositionColor, positionColors } from "./entityProfileConfig";

interface MemberCardProps {
  member: AssociatedPerson;
  positions: string[];
  onClick?: (person: AssociatedPerson) => void;
}

export const MemberCard: React.FC<MemberCardProps> = ({
  member,
  positions,
  onClick,
}) => {
  const primaryPosition = positions[0];
  const colors = primaryPosition
    ? getPositionColor(primaryPosition)
    : positionColors.default;

  return (
    <div
      onClick={() => onClick?.(member)}
      className={`p-3 rounded-lg border ${colors.border} hover:shadow-md cursor-pointer transition-all duration-200 ${colors.bg} bg-opacity-50`}
    >
      <div className="flex items-center gap-3">
        <div
          className={`w-10 h-10 rounded-full flex items-center justify-center ${colors.bg} ${colors.text}`}
        >
          <span className="text-sm font-bold">
            {member.firstName?.[0]}
            {member.lastName?.[0]}
          </span>
        </div>
        <div className="flex-1 min-w-0">
          <div className="font-medium text-gray-900 truncate">
            {member.firstName} {member.lastName}
          </div>
          {positions.length > 0 && (
            <div className="flex flex-wrap gap-1 mt-1">
              {positions.map((pos, idx) => {
                const posColors = getPositionColor(pos);
                return (
                  <span
                    key={idx}
                    className={`px-2 py-0.5 rounded text-xs font-medium ${posColors.bg} ${posColors.text}`}
                  >
                    {pos}
                  </span>
                );
              })}
            </div>
          )}
        </div>
      </div>
      <div className="mt-2 flex items-center gap-2">
        <span
          className={`px-2 py-0.5 rounded-full text-xs font-medium ${
            member.verificationStatus === "verified"
              ? "bg-green-100 text-green-800"
              : member.verificationStatus === "pending"
                ? "bg-yellow-100 text-yellow-800"
                : "bg-gray-100 text-gray-800"
          }`}
        >
          {member.verificationStatus.replace("-", " ").replace(/\b\w/g, c => c.toUpperCase())}
        </span>
        {member.appointmentDate && (
          <span className="text-xs text-gray-500">
            Since {formatDateShort(member.appointmentDate)}
          </span>
        )}
      </div>
    </div>
  );
};
